import {connect} from 'react-redux';

import * as actions from './actions';
import DocumentEdit from './document-edit';

const mapStateToProps = ({documents: {edit}}) => edit;
const mapDispatchToProps = (dispatch, props) => ({
  onCheckboxChange: event =>
    dispatch(actions.toggleCheckbox(event.currentTarget.name)),
  onClose: () => {
    props.onClose();
    return dispatch(actions.resetState());
  },
  onExternalNameChange: externalName =>
    dispatch(actions.updateExternalName(externalName)),
  onNameChange: name => dispatch(actions.updateName(name)),
  onNameCheck: name => dispatch(actions.checkName(name)),
  onSubmit: () => dispatch(actions.saveDocument()),
  onTextChange: text => dispatch(actions.updateText(text)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentEdit);
